/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
// core components
//import Header from "../../../../components/Headers/BasicHeader";
import Header from "./Header.js";
import { putUser, confirmReset } from "../../../../network/ApiAxios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import BasicModal from '../../../../components/Modals/BasicModal'
import { validateData } from '../../../../utils/views/pages/Dynamics'

const EditProfile = props => {

    let user = JSON.parse(secureLocalStorage.getItem("user"));
    const navigate = useNavigate();

    const [name, setName] = useState(user.name);
    const [email, setEmail] = useState(user.email);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState()
    const [modalGoTo, setModalGoTo] = useState()
    const validations = {
        name: '',
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        password: '',
    }

    /**
     * Essa função atualiza os dados do usuário e sua senha.
     * Aqui não deixaremos o usuário atualizar seu próprio email.
     * Além disso, tomaremos cuidado para atualizar os dados da 
     * localSession com os dados atualizados por este formulário
     */
    const editUser = async () => {
        setisLoading(true)

        //atualiza campos de dados pra enviar ao backend
        let updateUser = {
            name: name,             //apenas nome  
            password: password,     //e senha podem ser alterados
            image: user.image,
            email: user.email,
            userID: user._id        //definido com esse formato no backend
        }
        
        //verifica se o usuário forneceu senha e confirmação
        if (password !== confirmPassword || password?.length < 6) {

            setModalTitle("Error")
            setModalMessage("Passwords do not match or are too short!")
            setShowModal(true)

        //valida dados de acordo com o padrão basado em expressões regulares
        } else if (validateData(validations, updateUser, setModalTitle, setModalMessage, setShowModal)) {
            //atualiza dados do cadastro do usuário
            const response = await putUser(updateUser);
            const { data } = response;

            if (data.success) {
                //atualiza a senha com o método que aplica as regras específicas
                //sobre senha do sistema
                const response = await confirmReset(user._id, password);
                const { data } = response;

                if (data.success) {
                    setModalTitle("Information")
                    setModalMessage(data.msg)
                    setShowModal(true)
                    setModalGoTo('/admin/user-profile')

                    //atualiza os campos editados para gravar na sessão
                    user.name = name
                    secureLocalStorage.setItem("user", JSON.stringify(user))
                } else {
                    setModalTitle("Error")
                    setModalMessage(data.msg)
                    setShowModal(true)
                }
            } else {
                setModalTitle("Error")
                setModalMessage(data.msg)
                setShowModal(true)
            }
        }
        setisLoading(false)

    }

    return (
        <>
            <Header />
            {/* Page content */}

            <Container className="mt--7" fluid>
                <Row>
                    <div className="col">
                        <Card className="bg-secondary shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className="mb-0">Account editing</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>
                                    <h6 className="heading-small text-muted mb-4">
                                        User information
                                    </h6>
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-username"
                                                    >
                                                        Username
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        value={name}
                                                        id="input-username"
                                                        placeholder="Username"
                                                        onChange={e => setName(e.target.value)}
                                                        type="text"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-email"
                                                    >
                                                        Email address
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-email"
                                                        value={email}
                                                        type="email"
                                                        disabled={true}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-password"
                                                    >
                                                        Password
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        value={password}
                                                        id="input-password"
                                                        placeholder="Safe Password"
                                                        onChange={e => setPassword(e.target.value)}
                                                        type="password"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-confirm-password"
                                                    >
                                                        Confirm Password
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        value={confirmPassword}
                                                        id="input-confirm-password"
                                                        placeholder="Same Password"
                                                        onChange={e => setConfirmPassword(e.target.value)}
                                                        type="password"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                                <Row className="align-items-left">
                                    <Col className="text-left" xs="4">

                                        <Button onClick={() => navigate('/admin/user-profile')}
                                            className="btn-icon btn-3" color="primary" type="button">

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-bold-left" />
                                            </span>

                                            <span className="btn-inner--text">Back</span>

                                        </Button>

                                    </Col>

                                    {
                                        function () {
                                            return (

                                                <Col className="text-right" xs="8">
                                                    <Button onClick={editUser}
                                                        className="btn-icon btn-3" color="success" type="button"
                                                        disabled={isLoading}
                                                    >


                                                        {isLoading ? (

                                                            <Spinner size="sm" className="me-2 mx-1" />
                                                        ) :

                                                            (
                                                                <>
                                                                    <span className="btn-inner--icon">
                                                                        <i className="ni ni-check-bold" />
                                                                    </span>

                                                                    <span className="btn-inner--text">Confirm</span>
                                                                </>
                                                            )}


                                                    </Button>
                                                </Col>
                                            )
                                        }()
                                    }

                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                </Row>
            </Container>

            <BasicModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                handleGoTo={modalGoTo} />
        </>
    );
}

export default EditProfile;
